import { ajaxSend } from '../../../api/api';

const BASE_PATH = '/v1/ratings';

export function requestFeedback({ csid }) {
  return ajaxSend({
    method: 'GET',
    path: `${BASE_PATH}?csid=${encodeURIComponent(csid)}`,
  });
}
